export const UPDATE_ANSWER = 'UPDATE_ANSWER';
export const CLEAR_ANSWER = 'CLEAR_ANSWER';
export function updateAnswerAction(action) {
    return Object.assign({ type: UPDATE_ANSWER }, action);
}
export function clearAnswerAction() {
    return {
        type: CLEAR_ANSWER
    };
}
